import { Component, inject } from '@angular/core';
import {
  CoreUtilsService,
} from '@src/app/shared/services/core-utils/core-utils.service';

@Component({
  selector: 'cs-environment-ribbon',
  standalone: true,
  template: `
    <div class="fixed bottom-[18px] right-[-30px] z-[100] w-[200px] rotate-[-28deg] bg-theme-destructive text-center text-xs leading-7 text-white shadow-md">{{ envName }}</div>
  `
})
export class EnvironmentRibbonComponent {
  private utils = inject(CoreUtilsService)
  public envName: string = ''

  constructor() {
    const env = this.utils.getEnvironmentVariable("environment") as string ?? ''
    this.envName = env.toUpperCase()
  }
}
